export default function quoteCreateInv(data) {
  const params = { action: "quote_create_invoice", record: data.id };

  this.load();
  this.rest.post("customAction", params, (resp) => {
    if (resp.status) {
      this.href("#detail/acm_invoices/" + resp.message.data.record);
    } else {
      this.unLoad();
      this.alert(resp.errorMessage.text);
    }
  });

}
